import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { css, useTheme } from "@emotion/react"
import { fluidRange } from "polished"

export default function CreditFooter({ theme: appearance = "colour" }) {
  const theme = useTheme()
  const isLight = appearance === "light"
  const backgroundColor = isLight
    ? theme.colors.global.light
    : theme.colors.typeAndTixel.one
  const color = isLight
    ? theme.colors.typeAndTixel.one
    : theme.colors.global.light
  const linkBarColor = isLight
    ? theme.colors.typeAndTixel.one
    : theme.colors.global.light

  css.root = css`
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;
    align-items: flex-start;
    column-gap: 0.35em;
    padding-inline: ${theme.grid.gutter};
    padding-block: 30px;
    color: ${color};
    background-color: ${backgroundColor};
    ${fluidRange(
      {
        prop: "fontSize",
        fromSize: "12px",
        toSize: "12px",
      },
      theme.breakpoints.mobile,
      theme.breakpoints.desktop
    )}
    font-weight: ${theme.fontWeight.semiBold};
    letter-spacing: 0.2em;
    text-transform: uppercase;
  `

  css.link = css`
    position: relative;
    display: inline-block;
    padding-bottom: 6px;
    text-decoration: none;
    color: inherit;

    &:hover {
      &:before {
        animation-name: creditFooterLinkWipe;
      }
    }

    &:before {
      content: "";
      position: absolute;
      top: 100%;
      right: 0;
      left: 0;
      display: block;
      height: 1px;
      background-color: ${linkBarColor};
      transform-origin: left;
      transition-property: transform;
      transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
      animation-duration: 0.5s;
      transform-origin: right;
    }

    @keyframes creditFooterLinkWipe {
      50% {
        transform-origin: right;
        transform: scaleX(0);
      }
      50.001% {
        transform-origin: left;
      }
      100% {
        transform-origin: left;
        transform: scaleX(1);
      }
    }
  `

  return (
    <div css={css.root}>
      <span>Proudly part of the</span>
      <a
        css={css.link}
        href="https://colonygroup.co/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Colony Group
      </a>
    </div>
  )
}

CreditFooter.propTypes = {
  theme: PropTypes.oneOf(["light", "colour"]),
}

export const query = graphql`
  fragment CreditFooter on DataJsonComponentsProps {
    CreditFooter {
      theme
    }
  }
`
